<p-dialog
  header="Local sign-in"
  [modal]="true"
  [style]="{ width: '24rem' }"
  [draggable]="false"
  [(visible)]="service.visible"
  (onHide)="cancel()"
>
  <div class="local-sign-in-content">
    <label for="localSignInIdentity">Entra object id (GUID)</label>
    <input
      #identityInput
      pInputText
      id="localSignInIdentity"
      autocapitalize="off"
      [value]="identity()"
      (input)="identity.set(identityInput.value)"
      (keyup.enter)="submit()"
      data-testid="local-sign-in-identity"
    />
  </div>

  <ng-template pTemplate="footer">
    <div class="actions">
      <yt-y-button label="Cancel" [text]="true" (click)="cancel()" data-testid="local-sign-in-cancel"></yt-y-button>
      <yt-y-button
        label="Log In"
        [disabled]="!identity().trim()"
        (click)="submit()"
        data-testid="local-sign-in-submit"
      ></yt-y-button>
    </div>
  </ng-template>
</p-dialog>
